import { IonIcon } from '@ionic/react';
import { notificationsOutline } from 'ionicons/icons';
import { useActivityStore } from '../../store/useActivityStore';
import { CountBadge } from '../ui/CountBadge';

interface ActivityBellProps {
  onClick: () => void;
}

export const ActivityBell: React.FC<ActivityBellProps> = ({ onClick }) => {
  const activityCount = useActivityStore((s) => s.activityCount);

  return (
    <button
      onClick={onClick}
      // h-10 w-10 + centering matches the location pill's height so the two
      // controls line up vertically; text-muted-foreground matches the pill's
      // icon color (replacing the hardcoded gray) for a consistent top bar.
      className="relative flex h-10 w-10 items-center justify-center text-muted-foreground"
    >
      <IonIcon icon={notificationsOutline} className="text-2xl" />
      <CountBadge count={activityCount} className="-top-1 -right-1" />
    </button>
  );
};
